import React, { useState } from 'react';
import { ConstructionItem } from './ConstructionItem';
import { AdditionalItemsButton, NewConstructionWrapper } from './styled';
import { SmallText } from 'ds/components/typography';
import { useLocale } from 'locale';
import { INewDevelopmentJob } from 'store/state/selectors/insights/summaryTypes';

interface ShowMoreConstructionsProps {
  items: INewDevelopmentJob [];
  visibleRows: number;
  setActiveConstructionId: (id: string | number) => void;
}

export const ShowMoreConstructions: React.FunctionComponent<ShowMoreConstructionsProps> = ({ visibleRows, items, setActiveConstructionId }) => {
  const { t } = useLocale();
  const [ isCollapsed, setCollapsed ] = useState(true);
  const getHiddenRowsAmount = (count: number) => Math.max(count - visibleRows, 0);
  const handleClick = () => setCollapsed(!isCollapsed);

  return (
    <>
      {getHiddenRowsAmount(items.length) && isCollapsed
        ? null
        : items.slice(visibleRows, items.length).map((itemProps: INewDevelopmentJob, i: number) =>
          <NewConstructionWrapper
            key={i}
            onMouseEnter={() => setActiveConstructionId(itemProps.geoId)}
            onMouseLeave={() => setActiveConstructionId(null)}
          >
            <ConstructionItem {...itemProps}/>
          </NewConstructionWrapper>
        )
      }

      {getHiddenRowsAmount(items.length) ? (
        <AdditionalItemsButton onClick={handleClick}>
          {isCollapsed
            ? <SmallText>{t('transportationAccordion.seeAll', { amount: getHiddenRowsAmount(items.length) })}</SmallText>
            : <SmallText>{t('transportationAccordion.seeLess')}</SmallText>
          }
        </AdditionalItemsButton>
        ) : null
      }
    </>
  );
};

